import { render, staticRenderFns } from "./MaxxFormDisplay.vue?vue&type=template&id=3aa6deb2&scoped=true"
import script from "./MaxxFormDisplay.vue?vue&type=script&lang=js"
export * from "./MaxxFormDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa6deb2",
  null
  
)

export default component.exports